import React from 'react';
import "./QuestionNumber.css";

function QuestionNumber({ setSelectedQuestionNumber, selectedQuestionNumber, attemptedQuestions, markForReviewQuestionsArray, viewedQuestionsArray, handleFinishTest, finishTest, totalQuestions, attemptedAndMarkedForReview, isCUET }) {
  const numbers = new Array(totalQuestions).fill(0).map((_, i) => i + 1);
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const selectBGColor = (number) => {
    if (number == selectedQuestionNumber) {
      if (attemptedQuestions?.includes(number)) {
        return 'answernumberActive';
      } else if (markForReviewQuestionsArray?.includes(number)) {
        return 'markedanswernumberActive';
      } else {
        return 'numberActive';
      }
    } else if (isCUET && attemptedAndMarkedForReview?.includes(number)) {
      return 'markedAsReviewAndAttempted';
    } else if (attemptedQuestions?.includes(number)) {
      return 'answernumberActive';
    } else if (markForReviewQuestionsArray?.includes(number)) {
      return 'markedanswernumberActive';
    } else if (viewedQuestionsArray?.includes(number)) {
      return 'noanswernumberActive';
    }
  }

  return (
    <div className='d-flex justify-content-center flex-column align-items-center' onClick={handleScrollToTop}>
      <ul className='number-list'>
        {numbers.map((number) => (
          <li className={selectBGColor(number)} key={number} onClick={() => setSelectedQuestionNumber(number)}>{number}</li>
        ))}
      </ul>
      {!finishTest && <button type="button" onClick={handleFinishTest} className="btn bg-Question-orange btn-md">FINISH</button>}
    </div>
  );
}
export default QuestionNumber;
